import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { normalizePremiumFolderData } from '../../../../../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../../../../../types/deviation';
import { getDeviationResourceType, getDeviationType, } from '../../../../../_helpers';
var unlockHint = function (type, isMobile) {
    if (type === DeviationTypes.FILM) {
        return isMobile
            ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile.video'
            : 'deviationview.overlay.premiumFolder.unlockHint.pay.video';
    }
    return isMobile
        ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile'
        : 'deviationview.overlay.premiumFolder.unlockHint.pay';
};
var PremiumLockedMiddleContent = function (_a) {
    var _b;
    var deviation = _a.deviation, thumbWidth = _a.thumbWidth, thumbHeight = _a.thumbHeight, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = normalizePremiumFolderData(deviation.premiumFolderData), pointPrice = _c.pointPrice, folderId = _c.folderId, subproductId = _c.subproductId, formattedDollarPrice = _c.formattedDollarPrice;
    var showSmallButton = thumbWidth && thumbWidth < 250;
    var canShowDescription = thumbWidth &&
        thumbHeight &&
        thumbWidth > 230 &&
        (thumbWidth > 400 ? thumbHeight > 230 : thumbHeight > 260);
    var canShowButton = thumbHeight && thumbHeight > 200;
    var isUnreasonablySmall = (thumbHeight && thumbHeight < 160) || (thumbWidth && thumbWidth < 120);
    var buttonTitle = useMemo(function () {
        if (!canShowButton) {
            return;
        }
        if (showSmallButton) {
            return t('deviationview.overlay.premiumFolder.button.pay.short');
        }
        if (isMobile || pointPrice === undefined || pointPrice < 80) {
            return t('deviationview.overlay.premiumFolder.button.pay.mobile', {
                dollarPrice: formattedDollarPrice,
            });
        }
        return t('deviationview.overlay.premiumFolder.button.pay', {
            postProcess: 'reactPostprocessor',
            dollarPrice: formattedDollarPrice,
            pointPrice: pointPrice,
            pointsIcon: React.createElement(PointsIcon, { size: IconSize.TINY, disableDefaultColors: true }),
        });
    }, [
        canShowButton,
        formattedDollarPrice,
        isMobile,
        pointPrice,
        showSmallButton,
        t,
    ]);
    if (isUnreasonablySmall) {
        return (React.createElement(HoverOnly, { reverseHidden: true },
            React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-premium", size: "large" }), className: className })));
    }
    return (React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-premium", size: "large" }), subtitle: canShowDescription
            ? t(unlockHint(getDeviationType(deviation), isMobile))
            : undefined, buttonTitle: buttonTitle, biData: BiData({
            evid: 361,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            authorid: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid,
            galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
            points: pointPrice,
            rank: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }), buttonHref: subproductId ? Url.checkoutLink(subproductId) : undefined, className: className }));
};
PremiumLockedMiddleContent.displayName = 'PremiumLockedMiddleContent';
export default PremiumLockedMiddleContent;
//# sourceMappingURL=PremiumLockedMiddleContent.js.map